import {EventValidation} from './EventValidation';
import {QueryStringService} from './Services/QueryStringService';

export class FilterModule {

	constructor() {
		this.eventValidation = new EventValidation();
		this.$grid = $(".teasers");
		this.filterParamKey = 'filter';
		this.queryStringService = new QueryStringService();
		this.setIsotope();
		this.init();
	}

	init() {
		$("[data-filter-trigger]").on('click keyup', (e) => {
			if (this.eventValidation.isValidEvent(e)) {
				e.preventDefault();
				this.handleFilter($(e.currentTarget));
			}
		});
	}

	handleFilter($el) {
		let filterWord = $el.data('filter-trigger').toString();
		this.updateFilter($el, filterWord);
		this.updateView(filterWord);
	}

	updateFilter($el, filterWord) {
		$("[data-filter-trigger]").not($el).removeClass('active active-border');
		$el.addClass('active').removeClass('active-border');

		//add active border to previous elements
		if (filterWord.toLowerCase() !== 'all') {
			$el.prevAll().addClass('active-border');
		}
	}

	updateView(filterWord) {
		let selector = (filterWord.toLowerCase() == 'all') ? '*' : '.' + filterWord;
		this.$grid.isotope({filter: selector});

		this.updateFilterDescription(filterWord);
		this.scrollToTarget();
	}

	updateFilterDescription(filterWord) {
		$("[data-filter-description]").removeClass('active');
		$("[data-filter-description='" + filterWord + "']").addClass('active');
	}

	scrollToTarget() {
		let $targetLarge = $("[data-filter-scrolltarget-large]");
		let $targetSmall = $("[data-filter-scrolltarget-small]");

		//If no targets or window to large to ensure scrolling without jumping. Bail
		if ((!$targetLarge.length || !$targetSmall.length) || (window.innerWidth >= 1400 && window.innerHeight > 845)) {
			return;
		}

		let $target = (window.innerWidth >= 767) ? $targetLarge : $targetSmall;
		let margin = (window.innerWidth < 767) ? 20 : 0;

		$("html, body").animate({ scrollTop: ($target.offset().top - margin)}, 500);
	}

	/**
	 * Only invoke if filter exists. (ie trigger exists)
	 * Check for eventual queryString and invoke filter with filtering if exists and validates.
	 */
	setIsotope() {
		if (!$("[data-filter-trigger]").length) {
			return;
		}

		let filterParam = this.queryStringService.getQueryStringValue(this.filterParamKey);
		let isotopeFilter = '*';

		if (filterParam) {
			let $el = $("[data-filter-trigger='" + filterParam + "']");
			// if paramkey matches a trigger an element exists. Initiate filter with param as filter
			if ($el.length) {
				isotopeFilter = "." + filterParam;
				this.updateFilter($el, filterParam);
				this.updateFilterDescription(filterParam);
			}
		}

		this.$grid.isotope({
			filter: isotopeFilter,
			sortBy: 'original-order',
			itemSelector: '.teaser-item',
			transitionDuration: '0.5s',
			stagger: 30,
		});
	}

}
